module.exports = __webpack_public_path__ + "img/picto5.9851e8bd.svg";